import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/userInput'
  },
  {
    path: '/userInput',
    name: 'UserFormInput',
    component: () => import('@/views/UserFormInput.vue'),
    meta: {
      title: '用户信息输入'
    }
  },
  {
    path: '*',
    name: 'UserFormInput',
    component: () => import('../views/UserFormInput.vue'),
    meta: {
      title: '个人AI风控检测'
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  
  next();
});

export default router;